import type { VitalDef, VitalView } from './vitals.js';
import type { LayerState } from '@vitals/shared';

/**
 * Vital selector for NWS active weather alerts filtered to NYC.
 *
 * - value: alert count as a string ("3"), or "—" when down
 * - label: "weather alerts"
 */
export const alertsVital: VitalDef = {
  id: 'alerts',
  layerId: 'nws_alerts',

  select: (s: LayerState | undefined): VitalView => {
    const down = !s || s.status === 'down' || s.summary == null;

    if (down) {
      return {
        value: '—',
        label: 'alerts',
        down: true,
        stale: false,
      };
    }

    const summary = s.summary as {
      count: number;
      events: string[];
      alerts?: { event: string; severity: string; area: string }[];
    };
    const { count, events } = summary;

    return {
      value: `${count}`,
      label: 'alerts',
      down: false,
      stale: s.status === 'stale',
      detailTitle: 'Weather alerts',
      details: summary.alerts?.map(({ event, severity, area }) =>
        ({ kind: 'alert', title: event, meta: [severity, area].filter(Boolean).join(' · ') }),
      )
        ?? events.map((title) => ({ kind: 'alert', title })),
    };
  },
};
